import { render, staticRenderFns } from "./separator_widget.vue?vue&type=template&id=715dd970&scoped=true&lang=pug"
import script from "./separator_widget.vue?vue&type=script&lang=js"
export * from "./separator_widget.vue?vue&type=script&lang=js"
import style0 from "./separator_widget.vue?vue&type=style&index=0&id=715dd970&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715dd970",
  null
  
)

export default component.exports